/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim2DiagMinRightIcon24Regular = forwardRef('ArrowDim2DiagMinRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.53 3.53a.75.75 0 0 0-1.06-1.06l-6.72 6.72V4.5a.75.75 0 0 0-1.5 0v5.25a2 2 0 0 0 2 2h5.25a.75.75 0 0 0 0-1.5h-4.69l6.72-6.72Z" }),
        React.createElement("path", { d: "M10.25 19.5v-4.69l-6.72 6.72a.75.75 0 0 1-1.06-1.06l6.72-6.72H4.5a.75.75 0 0 1 0-1.5h5.25a2 2 0 0 1 2 2v5.25a.75.75 0 0 1-1.5 0Z" })));
});
